export const getActivityTableMinWidth = (activityCount: number) =>
  Math.max(1060, 740 + (activityCount * 300));

export const getActivityHeaderColSpan = (activityCount: number) =>
  (activityCount * 2) + 3;

export const getActivityRowKey = (rowIndex: number) => `activity-row-${rowIndex}`;

export const getActivityValueAriaLabel = (activityLabel: string) =>
  `Destination value for ${activityLabel}`;
